/* global Swiper */

document.querySelectorAll( '.b-timeline-slider' ).forEach( ( block ) => {

	if ( !block ) {

		return;

	}

	const nextButton = block.querySelector( '.swiper-button-next' )
	const prevButton = block.querySelector( '.swiper-button-prev' )

	/**
	 * Function that handles resizing of active elements in a pagination block
	 * Calculates the width and position of the active line within the block
	 * @function resizeHandler
	 */
	const resizeHandler = () => {

		const allActiveElements = block.querySelectorAll( '.c-timeline-pagination__element.c-timeline-pagination__element--active' );
		const firstActiveElement = allActiveElements[ 0 ];
		if( !firstActiveElement ) {

			return

		}
		const activeDot = block.querySelector( '.c-timeline-pagination__active-dot' )
		const activeLineLeft = firstActiveElement.offsetLeft - block.scrollLeft;
		const pagination = block.querySelector( '.c-timeline-pagination' )
		const paginationPaddingLeft = window.getComputedStyle( pagination ).getPropertyValue( 'padding-left' );
		if( activeDot ) {

			activeDot.style = `left: ${ parseFloat( paginationPaddingLeft ) + activeLineLeft + 1}px`;

		}

	};


	let previousActiveIndex = 0;

	const swiper = new Swiper( block, {
		watchOverflow: true,
		slidesPerView: 1,
		spaceBetween: 48,
		speed: 1000,
		autoplay: false,
		loop: false,
		autoHeight: true,
		navigation: {
			nextEl: nextButton,
			prevEl: prevButton,
		},
		keyboard: {
			enabled: true,
			onlyInViewport: true,
		},
		on: {
			init: ( event ) => {

				const activePaginationElements = block.querySelectorAll( `.c-timeline-pagination__element[data-index="${event.activeIndex}"]` );
				if ( activePaginationElements ) {

					activePaginationElements.forEach( ( activeElement ) => {

						activeElement.classList.add( 'c-timeline-pagination__element--active' );

					} );

				}

				const paginationElements = block.querySelectorAll( '.c-timeline-pagination__element' );

				paginationElements.forEach( ( element ) => {

					element.addEventListener( 'click', function elementHandler (){

						const index = Number( this.getAttribute( 'data-index' ) );
						swiper.slideTo( index );

					} );

				} );


				resizeHandler()

			},

			slideChange: ( event ) => {

				const currentlyActiveElements = block.querySelectorAll( '.c-timeline-pagination__element.c-timeline-pagination__element--active' );
				if ( currentlyActiveElements ) {

					currentlyActiveElements.forEach( ( activeElement ) => {

						activeElement.classList.remove( 'c-timeline-pagination__element--active' );

					} );

				}

				const activeElements = block.querySelectorAll( `.c-timeline-pagination__element[data-index="${event.activeIndex}"]` );
				if ( activeElements ) {

					activeElements.forEach( ( activeElement ) => {

						activeElement.classList.add( 'c-timeline-pagination__element--active' );

					} );

				}

				resizeHandler()

				const newActiveElements = block.querySelectorAll( `.c-timeline-pagination__element[data-index="${event.activeIndex}"]` );
				const scrollingContainer = block.querySelector( '.c-timeline-pagination' );
				if ( scrollingContainer && newActiveElements.length > 0 ) {

					const targetElement = event.activeIndex < previousActiveIndex ? newActiveElements[ 0 ] : newActiveElements[ newActiveElements.length - 1 ];
					scrollingContainer.scroll( {
						left: targetElement.offsetLeft,
						behavior: 'smooth'
					} );

				}

				previousActiveIndex = event.activeIndex;

			},
			resize: () => {

				resizeHandler();

			}
		}
	} );

} );
